import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation CreateField($params: CreateFieldInput!) {
    createField(params: $params) {
      id
    }
  }
`;

export interface FieldParams {
  name: string;
  currentCrop: string;
  farmId: string;
  geometry: {
    type: 'Polygon';
    coordinates: number[][][];
  };
}

export type MutateFn = (params: FieldParams) => void;

export type CompletedFn = (field: Field) => void;

interface Result {
  createField: Field;
}

interface Props {
  onCompleted: CompletedFn;
  children: (
    execute: MutateFn,
    loading: boolean,
    createdField: Field | undefined
  ) => React.ReactNode;
}

const NewFieldProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={(data: Result) =>
        data ? props.onCompleted(data.createField) : null
      }
    >
      {(mutateFn, result) =>
        props.children(
          (params: FieldParams) => mutateFn({ variables: { params } }),
          result.loading,
          result.data ? result.data.createField : undefined
        )
      }
    </AuthorizedMutation>
  );
};

export default NewFieldProvider;



// WEBPACK FOOTER //
// ./src/providers/NewFieldProvider.tsx